import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { familyAPI } from "../api";
import useAuthStore from "../store/auth";

const INVITE_TOKEN_KEY = "bf_pending_invite";

export default function JoinFamilyPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { token: authToken } = useAuthStore();
  const [invite, setInvite] = useState(null);
  const [loading, setLoading] = useState(true);
  const [joining, setJoining] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    familyAPI.getInvite(token)
      .then(r => setInvite(r.data.member))
      .catch(() => setError("Invitation invalide ou expiree."))
      .finally(() => setLoading(false));
  }, [token]);

  const handleAccept = async () => {
    setJoining(true);
    try {
      const res = await familyAPI.acceptInvite(token);
      localStorage.removeItem(INVITE_TOKEN_KEY);
      toast.success(res.data.message);
      navigate("/family");
    } catch (err) {
      toast.error(err.response?.data?.error || "Erreur");
    } finally { setJoining(false); }
  };

  const goToLogin = () => {
    localStorage.setItem(INVITE_TOKEN_KEY, token);
    navigate("/login");
  };

  const goToRegister = () => {
    localStorage.setItem(INVITE_TOKEN_KEY, token);
    navigate("/register");
  };

  // Si connecte, accepter directement
  useEffect(() => {
    if (authToken && invite && !loading) {
      handleAccept();
    }
  }, [authToken, invite, loading]);

  if (loading) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"var(--bg)" }}>
      <p style={{ color:"var(--text2)" }}>Chargement...</p>
    </div>
  );

  if (error) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"var(--bg)", padding:20 }}>
      <div style={{ background:"var(--surface)", border:"1px solid var(--border)", borderRadius:20, padding:40, maxWidth:400, width:"100%", textAlign:"center" }}>
        <div style={{ fontSize:64, marginBottom:16 }}>❌</div>
        <h2 style={{ fontFamily:"Syne,sans-serif", marginBottom:12 }}>Invitation invalide</h2>
        <p style={{ color:"var(--text2)", marginBottom:24 }}>{error}</p>
        <button onClick={() => navigate("/")} style={{ padding:"12px 24px", background:"var(--accent)", color:"#fff", border:"none", borderRadius:10, fontFamily:"Syne,sans-serif", fontWeight:700, cursor:"pointer" }}>
          Retour
        </button>
      </div>
    </div>
  );

  if (authToken) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"var(--bg)" }}>
      <p style={{ color:"var(--text2)" }}>Acceptation en cours...</p>
    </div>
  );

  return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"radial-gradient(ellipse 80% 60% at 50% -10%,#2d1f7a44,transparent),var(--bg)", padding:20 }}>
      <div style={{ background:"var(--surface)", border:"1px solid var(--border)", borderRadius:24, padding:48, maxWidth:460, width:"100%", textAlign:"center" }}>
        <div style={{ width:72, height:72, borderRadius:"50%", background:"linear-gradient(135deg,#7c6af7,#f7c26a)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:32, margin:"0 auto 24px" }}>
          👨‍👩‍👧
        </div>
        <div style={{ fontFamily:"Syne,sans-serif", fontSize:22, fontWeight:800, marginBottom:8 }}>
          Invitation au groupe familial
        </div>
        <p style={{ color:"var(--text2)", fontSize:15, lineHeight:1.7, marginBottom:8 }}>
          Vous avez ete invite a rejoindre
        </p>
        <div style={{ fontFamily:"Syne,sans-serif", fontSize:20, fontWeight:800, color:"var(--accent)", marginBottom:24 }}>
          {invite?.group_name}
        </div>

        <div style={{ background:"var(--surface2)", border:"1px solid var(--border)", borderRadius:12, padding:16, marginBottom:28, textAlign:"left" }}>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:8, fontSize:14 }}>
            <span style={{ color:"var(--text2)" }}>Invite</span>
            <span style={{ fontWeight:600 }}>{invite?.name}</span>
          </div>
          <div style={{ display:"flex", justifyContent:"space-between", fontSize:14 }}>
            <span style={{ color:"var(--text2)" }}>Role</span>
            <span style={{ fontWeight:600, color:"var(--accent)" }}>{invite?.role === "admin" ? "Administrateur" : "Membre"}</span>
          </div>
        </div>

        <div style={{ background:"#7c6af720", border:"1px solid #7c6af740", borderRadius:10, padding:12, marginBottom:24, fontSize:13, color:"var(--accent3)" }}>
          Connectez-vous ou creez un compte pour rejoindre le groupe. Votre invitation sera automatiquement acceptee.
        </div>

        <div style={{ display:"grid", gap:10 }}>
          <button onClick={goToLogin}
            style={{ width:"100%", padding:14, background:"var(--accent)", color:"#fff", border:"none", borderRadius:10, fontFamily:"Syne,sans-serif", fontWeight:700, fontSize:15, cursor:"pointer" }}>
            Se connecter
          </button>
          <button onClick={goToRegister}
            style={{ width:"100%", padding:14, background:"var(--surface2)", color:"var(--text)", border:"1px solid var(--border)", borderRadius:10, fontSize:15, cursor:"pointer" }}>
            Creer un compte
          </button>
        </div>
      </div>
    </div>
  );
}